import {Component} from 'react';
const {registerBlockType} = wp.blocks;
const {
  InspectorControls
} = wp.editor;
const {
  PanelBody,
} = wp.components;

// import CustomInspectorControls from "../../../gutenberg/js_common/CustomInspectorControls";
import * as helpers from './js_common/_helpers';
import CustomInspectorControls from "./js_common/CustomInspectorControls";
// import BlockShop from "../../../gutenberg/js_dzsap/BlockShop";

let __ = (arg) => {
  return arg;
};


if (wp.i18n) {
  __ = wp.i18n.__;
}

export class BlockFactoryContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mainOptions_expanded: false,
    }

  }




  render(){
    let onClickToggleOptions = (key) => () => {
      this.setState({
        [key]: !this.state[key]
      })
      setTimeout(()=>{
        // window.dzs_checkDependency();
      },2);
      window.dzs_checkDependency();
    };


    let player_inspector_controls = (
      <CustomInspectorControls
        arr_options={this.props.configAttributes}
        uploadButtonLabel={this.props.uploadButtonLabel}
        attributes={this.props.attributes}
        setAttributes={this.props.setAttributes}
      />
    );

    return (<div>


      <div className="dzs--gutenberg--extra-options">
        <h4>{__('Shop Filter')}: <em>{this.props.attributes.feed_from}</em></h4>
        <h5 onClick={onClickToggleOptions('mainOptions_expanded')}
            className="dzs--gutenberg--extra-options--trigger">{!this.state.mainOptions_expanded ? (
          <span>{__('Options')} &darr;</span>) : (<span>{__('Retract')}  &uarr;</span>)}</h5>
        <div className="dzs--gutenberg--extra-options--content">
          {this.state.mainOptions_expanded ? player_inspector_controls : ''}
        </div>
      </div>
    </div>);

  }

}